export default {
  balance: 'Use {{value}}p ({{moneyValue}})',
  states: {
    on: 'Yes',
    off: 'No',
  },
  feedback: {
    min_spending_limit_not_reached: 'You need minimum {{value}} points to redeem',
    max_spending_limit: 'Maximum spent {{value}} points per order',
  },
};
